import { Link, LinkMethodEnum } from 'api-client';

export const hasGET = (rel: string, links?: Link[]) => links?.find((link) => link.method === LinkMethodEnum.GET && link.rel === rel) !== undefined;

export const hasAction = (action: string, links?: Link[]) => links?.find((link) => link.action === action) !== undefined;

export const hasAnyAction = (actions: string[], links?: Link[]) =>
  links?.find((link) => actions.find((action) => action === link.action)) !== undefined;
